import * as React from 'react';
import {
  Box, Table, TableBody, TableCell, TableContainer, Button,
  TableHead, TableRow, Paper, Tooltip, Toolbar, Typography,
} from '@material-ui/core';
import { Download as DownloadIcon } from '@material-ui/icons';
import AnalyticsDownloadModal from './AnalyticsDownloadModal';

export default function MemberAnalysisesAmountTable(props) {
  const { rows } = props;
  const [open, setOpen] = React.useState(false);

  const getCsvItem = [
    { label: '会員番号', key: 'memberNo' },
    { label: '姓', key: 'memberLastName' },
    { label: '名', key: 'memberFirstName' },
    { label: '姓フリガナ', key: 'memberLastNameKana' },
    { label: '名フリガナ', key: 'memberFirstNameKana' },
    { label: '郵便番号', key: 'zipCode' },
    { label: '都道府県', key: 'prefecture' },
    { label: '市区町村', key: 'city' },
    { label: '町名・番地・部屋番号', key: 'street' },
    { label: '都道府県フリガナ', key: 'prefectureKana' },
    { label: '市区町村フリガナ', key: 'cityKana' },
    { label: '町名・番地・部屋番号フリガナ', key: 'streetKana' },
    { label: '総会計税込金額', key: 'includTaxAmount' },
    { label: '総会計税抜金額', key: 'excludTaxAmount' },
    { label: '総値引き金額', key: 'discountAmount' },
    { label: '利用回数', key: 'vistCount' },
  ];

  const onDownload = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Box>
        <Paper>
          <Toolbar>
            <Typography style={{ flex: '1 1 50%' }} color="inherit" variant="subtitle1" component="div" />
            <Tooltip title="CSVの出力">
              <Button color="secondary" variant="outlined" onClick={onDownload} startIcon={<DownloadIcon />}>CSVの出力</Button>
            </Tooltip>
          </Toolbar>
          <TableContainer sx={{ maxHeight: 600 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>会員番号</TableCell>
                  <TableCell>会員名</TableCell>
                  <TableCell>住所</TableCell>
                  <TableCell>総会計税込金額</TableCell>
                  <TableCell>総会計税抜金額</TableCell>
                  <TableCell>総値引き金額</TableCell>
                  <TableCell>利用回数</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow hover tabIndex={-1} key={row.memberNo}>
                    <TableCell>{row.memberNo}</TableCell>
                    <TableCell>
                      {row.storesName && (
                        <Tooltip title={row.storesName} placement="top">
                          <Box>
                            <Box>{`${row.memberLastNameKana} ${row.memberFirstNameKana}`}</Box>
                            <Box>{`${row.memberLastName} ${row.memberFirstName}`}</Box>
                          </Box>
                        </Tooltip>
                      )}
                      {!row.storesName && (
                        <Box>
                          <Box>{`${row.memberLastNameKana} ${row.memberFirstNameKana}`}</Box>
                          <Box>{`${row.memberLastName} ${row.memberFirstName}`}</Box>
                        </Box>
                      )}
                    </TableCell>
                    <TableCell key="memberAddress">
                      <Box display={row.zipCode ? '' : 'none'}>{`〒${row.zipCode}`}</Box>
                      <Box>{`${row.prefectureKana}${row.cityKana}${row.streetKana}`}</Box>
                      <Box>{`${row.prefecture}${row.city}${row.street}`}</Box>
                    </TableCell>
                    <TableCell>{`${row.includTaxAmount.toLocaleString()}円`}</TableCell>
                    <TableCell>{`${row.excludTaxAmount.toLocaleString()}円`}</TableCell>
                    <TableCell>{`${row.discountAmount.toLocaleString()}円`}</TableCell>
                    <TableCell>{`${row.vistCount.toLocaleString()}回`}</TableCell>
                  </TableRow>
                ))}
                {rows.length <= 0 && (
                  <TableRow>
                    <TableCell style={{ textAlign: 'center' }} colSpan={6}>会員情報がありません</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
      <AnalyticsDownloadModal
        open={open}
        onClose={onClose}
        datas={rows}
        items={getCsvItem}
      />
    </>
  );
}
